import { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import { MessageContext } from "../context/MessageContext";

function Header() {
    const [isDarkMode, setIsDarkMode] = useState(window.matchMedia("(prefers-color-scheme: dark)").matches);
    const { isAuthenticated, user, login, logout, loading } = useContext(AuthContext);
    const { setMess } = useContext(MessageContext);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [Managerlogin, setManagerLogin] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const navigate = useNavigate();
    //------------------------------------------------------------------------------------------
    //------------------------------------------------------------------------------------------
    useEffect(() => {

        isDarkMode ? document.documentElement.classList = "dark" : document.documentElement.classList = "";

    }, []);

    const renderMenu = () => {
        if (isAuthenticated) {
            return (
                <>
                    <Link to="/CarRequests" className="text-sm sm:text-base px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-800">
                        Заявки
                    </Link>
                    <Link to="/carOffers" className="text-sm sm:text-base px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-800">
                        Предложения
                    </Link>
                    <Link to="/profile" className="text-sm sm:text-base hidden md:flex px-4 py-2 rounded-md text-white buttonGreen">
                        {user?.username ? user.username.slice(0, 10) : "Профиль"}
                    </Link>
                    <button onClick={handleLogout} className="text-sm sm:text-base hidden md:flex px-4 py-2 rounded-md text-white buttonRed">
                        Выход
                    </button>
                </>
            );
        } else {
            return (
                <button onClick={openModal} className="px-4 py-2 rounded-md bg-blue-500 text-white hover:bg-blue-600">
                    Логин
                </button>
            );
        }
    };


    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleTheme = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle("dark");
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate("/");
            setIsMobileMenuOpen(false);
        } catch (error) {
            console.error("Ошибка при выходе: ", error);
        }
    };

    const validateLogin = () => {
        if (!Managerlogin || !password) {
            setLoginError("Введите логин и пароль");
            return false;
        }
        if (Managerlogin.length < 3) {
            setLoginError("Логин слишком короткий");
            return false;
        }
        if (password.length < 6) {
            setLoginError("Пароль должен быть не менее 6 символов");
            return false;
        }
        setLoginError("");
        return true;
    };

    const SellerAuth = async () => {
        if (!validateLogin()) return;
        await login(Managerlogin, password)
            .then((res) => {
                setIsModalOpen(false);
                console.log("Header.jsx SellerAuth Успешная авторизация ", res);
                setMess({ color: 'green', title: 'Успешная авторизация', desc: `Вы авторизовались как: ${res.user.username}` });
                //window.location.reload();
            })
            .catch((error) => {
                console.error('Header.jsx SellerAuth Ошибка при авторизации:', error);
                setLoginError(error.message);
            });
    };

    const quickLogin = (userEmail) => {
        setManagerLogin(userEmail);
        setPassword('983270');
    };

    const openModal = () => { setIsModalOpen(true); };

    const closeModal = () => { setIsModalOpen(false); };

    if (loading) return (<div><p>Загрузка...</p></div>);

    return (
        <>
            <header>
                <nav className="px-2 bg-white dark:bg-gray-900 shadow-md border-b border-green-500">
                    <div className="container mx-auto">
                        <div className="flex justify-between items-center h-16">
                            {/* Logo and brand */}
                            <div className="flex items-center">
                                <Link to="/" className="px-3 py-1 sm:ph-2 rounded-md bg-green-50 hover:bg-green-100 dark:bg-gray-800 dark:hover:bg-green-900 transition-colors duration-200">
                                    <span className="hidden md:inline text-green-600 dark:text-green-400 text-2xl font-bold tracking-tight">WeKuplusam</span>
                                    <span className="inline md:hidden text-green-600 dark:text-green-400 text-xl font-bold">WK</span>
                                </Link>
                            </div>
                            {/* Desktop menu */}
                            <div className="flex items-center space-x-2 sm:space-x-4">
                                <div className={`flex items-center space-x-2 sm:space-x-4 *:transition-all *:duration-300`}>
                                    {renderMenu()}
                                </div>
                                {/* Mobile menu button for authenticated users */}
                                {isAuthenticated && (
                                    <div className="md:hidden flex items-center ">
                                        <button onClick={toggleMobileMenu} className="px-2 py-2 rounded-md bg-green-50 hover:bg-green-100 dark:bg-gray-800 dark:hover:bg-green-900 transition-colors duration-200" aria-label="Toggle menu">
                                            <svg id="menu-icon" xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 sm:h-6 sm:w-6 ${isMobileMenuOpen ? "hidden" : "block"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                                <line x1="3" y1="18" x2="21" y2="18"></line>
                                            </svg>
                                            <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 sm:h-6 sm:w-6 ${isMobileMenuOpen ? "block" : "hidden"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                            </svg>
                                        </button>
                                    </div>
                                )}
                                {/* Theme toggle */}
                                <button onClick={toggleTheme} className="px-2 py-2 rounded-full bg-green-50 hover:bg-green-100 dark:bg-gray-800 dark:hover:bg-green-900 transition-colors duration-200" aria-label="Toggle theme">
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isDarkMode ? "block" : "hidden"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isDarkMode ? "hidden" : "block"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="5"></circle>
                                        <line x1="12" y1="1" x2="12" y2="3"></line>
                                        <line x1="12" y1="21" x2="12" y2="23"></line>
                                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                                        <line x1="1" y1="12" x2="3" y2="12"></line>
                                        <line x1="21" y1="12" x2="23" y2="12"></line>
                                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {/* Меню на телефоне */}
                        <div className={`md:hidden bg-white dark:bg-gray-900 shadow-lg border-t border-green-500 ${isMobileMenuOpen ? "block" : "hidden"}`}>
                            <div className="px-2 pt-2 pb-3 space-y-1">
                                {isAuthenticated && (
                                    <>
                                        <Link to="/profile" className="block px-3 py-2 rounded-md text-white buttonGreen transition-colors duration-200" onClick={toggleMobileMenu}>
                                             {user?.username ? user.username.slice(0, 10) : "Профиль"}
                                        </Link>
                                        <button onClick={handleLogout} className="block w-full text-left px-3 py-2 rounded-md text-white buttonRed transition-colors duration-200">
                                            Выход
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </nav>
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeModal}>
                        <div className="bg-white dark:bg-gray-900 rounded-lg p-6 max-w-sm w-full relative" onClick={(e) => e.stopPropagation()}>
                            <button onClick={closeModal} className="absolute top-2 right-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                                Вход для продавца
                            </h3>
                            <form className="space-y-4" onSubmit={e => { e.preventDefault(); SellerAuth(); }}>
                                <input
                                    type="text"
                                    placeholder="Логин или Email"
                                    className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:border-green-400"
                                    value={Managerlogin}
                                    onChange={e => setManagerLogin(e.target.value)}
                                    autoFocus
                                />
                                <input
                                    type="password"
                                    placeholder="Пароль"
                                    className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:border-green-400"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                {loginError && <div className="text-red-500 text-sm">{loginError}</div>}
                                <button type="submit" className="w-full px-4 py-2 rounded-md bg-green-500 text-white hover:bg-green-600 transition-colors duration-200">Вход</button>
                            </form>
                            <div className="mt-8 pt-6 border-t border-gray-200">
                                <p className="text-sm text-gray-600 text-center mb-4">Demo accounts:</p>
                                <div className="space-y-2">
                                    <button
                                        onClick={() => quickLogin('login@mail.ru')}
                                        className="w-full text-left px-4 py-2 bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-800 rounded-md transition-colors duration-200 text-sm"
                                    >
                                        <strong>Manager:</strong> login@mail.ru
                                    </button>
                                    <button
                                        onClick={() => quickLogin('max_2002@bk.ru')}
                                        className="w-full text-left px-4 py-2 bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-800 rounded-md transition-colors duration-200 text-sm"
                                    >
                                        <strong>Manager 2:</strong> max_2002@bk.ru
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </header>
        </>
    )
}

export default Header

